@if (environmentKey && systemEnv(); as systemEnv) {
  <nav class="navbar text-white p-1 w-100 bg-{{ envColors[environmentKey] }}-contrast">
    <div class="mx-2">
      <i class="fa fa-exclamation-triangle me-2"></i>
      <strong>Environment:</strong> {{ environmentKey }} --- <strong>Database:</strong> {{ systemEnv.database }} ---
      <strong>Webserver:</strong>
      {{ systemEnv.webserver }}
    </div>
  </nav>
}
